import React from "react";
import { ExpressionBuilder } from "../ExpressionBuilder";
import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";

import { AddExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AddExpression";
import { SumExpression } from "../../rule-engine-core/Expressions/Expressions/Math/SumExpression";
import { DivideExpression } from "../../rule-engine-core/Expressions/Expressions/Math/DivideExpression";
import { expressionStoryData } from "../Testing/ExpressionData";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";
import { ExpressionValueType } from "../../rule-engine-core/Expressions/ExpressionValueType";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

function getMathExpression(): ExpressionConfiguration {
    let exp = new ExpressionConfiguration();
    exp.executionResult = new NumberDataDefinition();

    let baseExpression = new AddExpression();
    baseExpression.value1.value = 4;

    let subExpression = new AddExpression();
    subExpression.value1.variableName = "income";

    let sum = new SumExpression();
    sum.value1.variableName = "otherIncome";
    subExpression.value2.subExpression = sum;

    baseExpression.value2.subExpression = subExpression;

    exp.expression = baseExpression;

    return exp;
}

function getMathExpressionDivide(): ExpressionConfiguration {
    let exp = new ExpressionConfiguration();
    exp.executionResult = new NumberDataDefinition();

    let baseExpression = new AddExpression();
    baseExpression.value1.value = 4;
    baseExpression.value1.valueType = ExpressionValueType.VALUE;

    let subExpression = new AddExpression();
    subExpression.value1.variableName = "income";
    subExpression.value1.valueType = ExpressionValueType.VARIABLE;

    let divide = new DivideExpression();
    divide.divideValue.variableName = "otherIncome";
    divide.divideBy.value = 20;
    subExpression.value2.subExpression = divide;
    subExpression.value2.valueType = ExpressionValueType.SUBEXPRESSION;

    baseExpression.value2.subExpression = subExpression;
    baseExpression.value2.valueType = ExpressionValueType.SUBEXPRESSION;
    exp.expression = baseExpression;

    return exp;
}

function getMathExpressionValid(): ExpressionConfiguration {
    let exp = new ExpressionConfiguration();
    exp.executionResult = new NumberDataDefinition();

    let baseExpression = new AddExpression();
    baseExpression.value1.value = "asdf";
    baseExpression.value1.valueType = ExpressionValueType.VALUE;

    let subExpression = new AddExpression();
    subExpression.value1.variableName = "wrongField";
    subExpression.value1.valueType = ExpressionValueType.VARIABLE;

    let divide = new DivideExpression();
    divide.divideValue.variableName = "otherIncome";
    divide.divideValue.valueType = ExpressionValueType.VARIABLE;

    divide.divideBy.value = "asdfasd";
    divide.divideBy.valueType = ExpressionValueType.VALUE;

    subExpression.value2.subExpression = divide;
    subExpression.value2.valueType = ExpressionValueType.SUBEXPRESSION;

    baseExpression.value2.subExpression = subExpression;
    baseExpression.value2.valueType = ExpressionValueType.SUBEXPRESSION;

    exp.expression = baseExpression;

    return exp;
}

export const ExpressionEditorStories = [
    new StoryNode(
        () => {
            let exp = new ExpressionConfiguration();

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "General",
        "Blank",
    ),

    new StoryNode(
        () => {
            let exp = new ExpressionConfiguration();

            exp.variableName = "incomeName";

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "General",
        "Return Variable",
    ),

    new StoryNode(
        () => {
            let exp = new ExpressionConfiguration();

            exp.variableName = "incomeName";

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "General",
        "Return Variable",
    ),

    new StoryNode(
        () => {
            let exp = new ExpressionConfiguration();

            exp = getMathExpression();

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "General",
        "Math Expression",
    ),

    new StoryNode(
        () => {
            let exp = new ExpressionConfiguration();

            exp = getMathExpressionDivide();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "General",
        "Math Expression (Divide)",
    ),

    new StoryNode(
        () => {
            let exp = new ExpressionConfiguration();

            exp = getMathExpressionValid();
            exp.inputData = new DataDefinition();

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "General",
        "Math Expression (Validation)",
    ),
];
